import React from 'react';

import UserLayout from '../../shared/layouts/user-layout';
import AccountComp from '../../components/account-comps';

const Account = () => {

    return (

        <UserLayout>
            <AccountComp />
        </UserLayout>
    )
}

export default Account;


